export default __webpack_public_path__ + "static/media/rightArrow.8c096714.svg";